import { initReactI18next } from 'react-i18next'
import HttpApi from 'i18next-http-backend'
import i18n from 'i18next'
import ICU from 'i18next-icu'

// eslint-disable-next-line
import languageMap from '@amzn/katal-localization/dist/webpack/localization-loader!'
import LanguageDetector from 'i18next-browser-languagedetector'
import { getMetricsPublisherChainAsync } from '@amzn/aapn-front-end-metrics'

// TODO: incorporate i18next-icu addon if we want to have pluralization / selection support
// Tracking https://issues.amazon.com/issues/KAT-3174 for conversion support for that format
// https://w.amazon.com/bin/view/INTech/Panther/Architecture/PantherFileFormat/JSON/ for panther format examples

if (Object.keys(languageMap).length > 0) {
  i18n.use(HttpApi)
}

i18n
  .use(ICU)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    preload: ['ar-AE', 'hi-IN', 'th-TH', 'vi-VN'],
    partialBundledLanguages: true,
    nsSeparator: '-',
    debug: false,
    fallbackLng: ['en-US'],
    load: 'currentOnly',
    backend: {
      crossDomain: true,
      withCredentials: true,
      requestOptions: {
        credentials: 'include',
      },
      loadPath: (localeList: string[]) => {
        return '/partner-directory-assets/' + languageMap[localeList[0]]
      },
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    saveMissing: true,
    missingKeyHandler: (fallbackLng, ns, key) => {
      // This handler will only execute as a last resort when no fallback was found
      try {
        getMetricsPublisherChainAsync('i18n').then(p =>
          p
            .publishCounter(`missingKey.${key}`, 1)
            .publishCounter('missingKey', 1)
            .publishString('key', key),
        )
        process.env.NODE_ENV === 'development' && console.error(`missingKey.${key}`)
      } catch (error) {
        console.error(error)
      }
    },
  })

export default i18n
